import React, { useState, useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import illustration from '../../assets/Illustration.png'
import { LucideChevronDown, LucideChevronUp } from 'lucide-react'

import signup from "../../assets/signUp.png";
import addItems from "../../assets/addItems.png";


const StepsComponent = ({ t, autoPlay = true, autoPlayInterval = 3000 }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [isPlaying, setIsPlaying] = useState(autoPlay);
    
    const data = [
        { title: "sign_up", caption: "sign_up_caption", image: signup, id: 1 },
        { title: "add_your_items", caption: "add_your_items_caption", image: addItems, id: 2 },
        { title: "publish", caption: "publish_caption", image: addItems, id: 3 },
        { title: "enjoy", caption: "enjoy_caption", image: addItems, id: 4 },
    ];

    // Auto-play functionality
    useEffect(() => {
        let interval;
        
        if (isPlaying) {
            interval = setInterval(() => {
                setCurrentStep((prevStep) => {
                    if (prevStep === data.length - 1) {
                        // Option 1: Loop back to beginning
                        return 0;
                        // Option 2: Stop at the end and pause
                        // setIsPlaying(false);
                        // return prevStep;
                    }
                    return prevStep + 1;
                });
            }, autoPlayInterval);
        }
        
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [isPlaying, data.length, autoPlayInterval]);

    const nextStep = () => {
        setCurrentStep((prev) => {
            if (prev < data.length - 1) {
                return prev + 1;
            }
            return prev;
        });
        // Reset auto-play timer when manually navigating
        resetAutoPlay();
    };

    const prevStep = () => {
        setCurrentStep((prev) => {
            if (prev > 0) {
                return prev - 1;
            }
            return prev;
        });
        // Reset auto-play timer when manually navigating
        resetAutoPlay();
    };

    const resetAutoPlay = () => {
        if (autoPlay) {
            // Pause and restart auto-play
            setIsPlaying(false);
            setTimeout(() => setIsPlaying(true), 100);
        }
    };

    const toggleAutoPlay = () => {
        setIsPlaying(!isPlaying);
    };

    function Stepper({
        steps,
        currentStep,
        onStepChange,
        allowStepClick = true,
    }) {
        const handleKeyDown = (e, index) => {
            if (e.key === "ArrowDown" || e.key === "ArrowRight") {
                e.preventDefault();
                const next = Math.min(index + 1, steps.length - 1);
                onStepChange(next);
                resetAutoPlay();
            }

            if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
                e.preventDefault();
                const prev = Math.max(index - 1, 0);
                onStepChange(prev);
                resetAutoPlay();
            }
        };

        return (
            <div
                className="stepper-wrapper"
                role="tablist"
                aria-orientation="vertical"
            >
                {steps.map((step, index) => {
                    const isActive = currentStep === index;
                    const isCompleted = currentStep > index;

                    return (
                        <div
                            className="step-item d-flex"
                            key={index}
                        >
                            {/* Left Timeline */}
                            <div className="step-indicator-wrapper">
                                <button
                                    type="button"
                                    className={`step-indicator 
                  ${isActive ? "active" : ""} 
                  ${isCompleted ? "completed" : ""}
                `}
                                    onClick={() => {
                                        if (allowStepClick) {
                                            onStepChange(index);
                                            resetAutoPlay();
                                        }
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    aria-current={isActive ? "step" : undefined}
                                    aria-selected={isActive}
                                    role="tab"
                                    tabIndex={0}
                                >
                                    {step.id}
                                </button>

                                {index !== steps.length - 1 && (
                                    <div
                                        className={`step-line ${currentStep > index ? "filled" : ""
                                            }`}
                                    />
                                )}
                            </div>

                            {/* Content */}
                            <div className="step-content">
                                
                                <h3
                                    className={`step-title ${isActive ? "active" : "" }`}>
                                    {t(step.title)}
                                </h3>

                                <p className="step-description">
                                    {t(step.caption)}
                                </p>

                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
    
    return (
        <div className='py-5'>
            <div className='fs-1 text-center' dangerouslySetInnerHTML={{ __html: t('steps_title') }}></div>
            <p className='opacity-75 text-center'>{t('steps_caption')}</p>

            <div className=" ">
                <div className="row align-items-center py-5">
                    {/* LEFT SIDE */}
                    <div className="col-lg-5 pe-lg-5 px-4 py-1">
                        <Stepper
                            steps={data}
                            currentStep={currentStep}
                            onStepChange={setCurrentStep}
                        />
                    </div>

                    {/* RIGHT SIDE PREVIEW */}
                    <div className="col-lg-7 d-none d-lg-flex flex-column justify-content-center align-items-end">
                        <div className="dashboard-preview">
                            <img
                                src={data[currentStep].image}
                                alt={t(data[currentStep].title)}
                                className="img-fluid preview-image "
                               
                            />
                        </div>

                        {/* Navigation */}
                        <div className="d-flex gap-3 mt-4">
                            <button
                                className="btn btn-outline-dark p-3 rounded-pill"
                                onClick={prevStep}
                                disabled={currentStep === 0}
                            >
                                <LucideChevronUp />
                            </button>

                            <button
                                className="btn btn-purple p-3 rounded-pill"
                                onClick={nextStep}
                                disabled={currentStep === data.length - 1}
                            >
                                <LucideChevronDown />
                            </button>
                            
                           
                        </div>
                        
                        {/* Optional: Progress indicator */}
                        <div className="mt-3 text-center">
                            <small className="text-muted">
                                {currentStep + 1} / {data.length}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StepsComponent;